// @vendors
import { React, useContext, useState, useEffect } from 'react';
import { Slider, Form } from 'antd';
import Context from '../../../context/appContext';

// @styles 
import './styles.scss'

export default function ProgressBar({ info }) {
    const { dataForm: { formResponses } } = useContext(Context);
    const [sliderValue, setSliderValue] = useState(0);
    
    useEffect(() => {
        if (info && info.defaultValue >= 0) {
            setValue(info.defaultValue);
        }
    }, []);

    const onChange = (value) => {
        setValue(value);
    }

    const setValue = (value) => {
        info.value = value;
        setSliderValue(value)
        const index = formResponses.findIndex(x => x.key === info.key);
        index != -1 ? formResponses[index].value = value : formResponses.push(info);
    }


    return (
        <Form>
            <Form.Item
                name={info.key}
                label={info.label}
                className="percentage"
            >
                <span className='ant-form-item-control-input-content-text'>{sliderValue}%</span>
                <Slider
                    disabled={info && info.disabled ? true : false}
                    defaultValue={info && info.defaultValue ? info.defaultValue : 0}
                    min={info && info.validate && info.validate.min ? info.validate.min : 0}
                    max={info && info.validate && info.validate.max ? info.validate.max : 100}
                    onChange={onChange}
                    tooltipVisible={false}
                />
            </Form.Item>
        </Form>
    )
}
